import React from 'react';

import ErrorNotFound from '@ratedpeople/error-not-found';
import Layout from '../components/Layout';

export default function PageNotFound() {
  return (
    <Layout>
      <ErrorNotFound restApiHostname={process.env.GATSBY_REST_API_HOSTNAME} />
    </Layout>
  );
}
